import React from 'react';
import { Container } from 'react-bootstrap';
import certificado from '../data/inicio/certificado.svg';
import materialImpreso from '../data/inicio/24_7-03.svg';
import soporte24_7 from '../data/inicio/24_7-02.svg';
import './BenefitsSection.css';

const BenefitsSection = ({ onVerifyCertificate, isVerifying }) => {
  const benefitsData = [
    {
      title: 'Material Impreso',
      type: 'image',
      content: materialImpreso,
      description: 'Semilla para debates: conecta discusiones presenciales con tu progreso virtual'
    },
    {
      title: 'Soporte 24/7',
      type: 'video',
      content: soporte24_7,
      description: 'Modelo híbrido: WhatsApp + Clases estructuradas'
    },
    {
      title: 'Certificación Digital',
      type: 'image',
      content: certificado,
      description: 'Reconocimiento de Participación con Verificación Digital'
    }
  ];

  return (
    <section className="benefits-section">
      <Container className="benefits-container">
        <h2 className="section-title">¿Por qué elegirnos?</h2>
        
        <div className="benefits-grid">
          {benefitsData.map((item, index) => (
            <div className="benefit-card" key={index}>
              <div className="media-container">
                <img
                  src={item.content}
                  alt={item.title}
                  className={item.type === 'video' ? 'support-media' : 'benefit-media'}
                />
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>

        <div className="verification-container">
          <button
            onClick={onVerifyCertificate}
            className="cta-certificate"
            disabled={isVerifying}
          >
            {isVerifying ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Verificando...
              </>
            ) : (
              '🔍 Verificar a un Estudiantes'
            )}
          </button>
        </div>
      </Container>
    </section>
  );
};

export default BenefitsSection;